import * as React from 'react';
import { FvcAnalysisSetListTable } from './FvcAnalysisSetListTable';
import DocumentTitle from '../../../misc/components/DocumentTitle';
import { ODataParams, Query, SearchParams } from '../../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { QueryOfFvcAnalysisSet } from 'webportalclient';
import { OverreadStatusIdEnum } from '../../../misc/api/apiTypes';

export const FvcAnalysisSetListScreen = ({ cachedQuery, setCachedQuery }) => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleQueryCompleted = async (params: SearchParams) => {
        setCachedQuery(params);
    }

    const handleRefresh = async (params: ODataParams): Promise<QueryOfFvcAnalysisSet> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `session/visit/subject/site/studyId eq ${study.id}`;
        return await client.client.getSpirometryAnalysisSets('id,sessionId,started,created,type,status,user', filter, params.orderby, 'session($select=id,name,overreadChallengeStatus,challengeIsClosed;$expand=visit($select=id,name;$expand=subject($select=id,number,typeKey,typeName,site;$expand=site($select=id,number,studyId))))', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="FVC Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}
                initialFilters={[
                    { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                ]}
                initialOrdering={[{ field: "created", condition: "asc" }]}
                onQueryCompleted={handleQueryCompleted}
                savedQuery={cachedQuery}
            >
                <FvcAnalysisSetListTable />
            </Query>
        </DocumentTitle>
    );
};

export default FvcAnalysisSetListScreen;
